import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';

const OAuthCallback = () => {
  const location = useLocation();
  const [code, setCode] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const authCode = params.get('code');
    const authError = params.get('error');

    if (authCode) {
      setCode(authCode);
    } else if (authError) {
      setError(authError);
    }
  }, [location]);

  if (error) {
    return (
      <Box sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: 4 }}>
        <Typography variant="h4" color="error" gutterBottom>
          Authorization Error
        </Typography>
        <Typography>{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Email Alias Authorization
      </Typography>
      
      {code ? (
        <>
          <Typography gutterBottom>
            Your authorization code is:
          </Typography>
          <Paper sx={{ p: 2, bgcolor: '#f5f5f5', mb: 2 }}>
            <Typography component="pre" sx={{ wordBreak: 'break-all' }}>
              {code}
            </Typography>
          </Paper>
          <Typography>
            Copy this code and paste it back in your terminal.
          </Typography>
        </>
      ) : (
        <Typography>
          Processing authorization...
        </Typography>
      )}
    </Box>
  );
};

export default OAuthCallback;